import styled from "styled-components";
import {} from "react-bootstrap";

const ContentButton = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem 0 0 0;
`;

export default ContentButton;
